import { queryOptions } from '@tanstack/react-query';

import type { InstrumentOverviewPageData } from './get-instrument-overview-page-data.ts';
import { getInstrumentOverviewPageData } from './get-instrument-overview-page-data.ts';

interface GetInstrumentOverviewPageDataQueryOptionsInput {
	readonly ticker: string;
}

export function getInstrumentOverviewPageDataQueryOptions({ ticker }: GetInstrumentOverviewPageDataQueryOptionsInput) {
	return queryOptions<InstrumentOverviewPageData>({
		queryFn: () => getInstrumentOverviewPageData({ data: { ticker } }),
		queryKey: ['instrument-overview-page-data', ticker] as const,
	});
}
